import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px 16px;
  padding-bottom: 20px;
`

export const Content = styled.div`
  ${customizeVerticalScrollbarThumbMixin()}
  overflow: auto;
  flex: 1;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  & > div {
    flex: 1;
    min-width: 0;
  }
`
